import { render, staticRenderFns } from "./PainelPdtic2021.vue?vue&type=template&id=2328f7bf"
import script from "./PainelPdtic2021.vue?vue&type=script&lang=js"
export * from "./PainelPdtic2021.vue?vue&type=script&lang=js"
import style0 from "./PainelPdtic2021.vue?vue&type=style&index=0&id=2328f7bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports